import { useEffect } from "react";
import { listenNotice } from "@/api/_tafFetch";
import logger from "@/utils/logger";
import Toast from "@/components/Toast";
// 使用 react-query 控制异步数据状态
import { useQuery } from "react-query";
import { getLuckyBagPanel } from "../api";

export function useListenMainPanelEvent(dispatch: Function, deps: any[] = []) {
  useEffect(() => {
    listenNotice(6700, data => {
      Toast.show(`接收 uri: ${6700} mock 数据`);
      logger.log(`接收 uri: ${6700} mock 数据：`, data);
      dispatch && dispatch(data);
    });
  }, deps);
}

export function useMainPanel() {
  return useQuery("main", async () => {
    const res = await getLuckyBagPanel();
    return res;
  });
}
